export default __webpack_public_path__ + "static/media/logo.e8337182.svg";